const formatarData = (data: any) => {
  const opcoes = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  };

  const dataFormatada = data.toLocaleDateString('pt-BR', opcoes);

  return dataFormatada.replace(/^\d+/, (dia: any) => dia.padStart(2, '0'));
}

export default formatarData;
